<template>
	<div class="solution-manual-page">
		<Head />
		<main class="manual-main">
			<section class="banner-section section-py">
				<div class="container-custom banner-grid">
					<div>
						<h1 class="banner-title">心理咨询机构专属<br>全场景测评服务中台</h1>
						<p class="banner-desc">
							一站式可私有化部署、多租户独立管理、全终端适配，助力机构拓展服务场景、提升服务效率、沉淀用户数据，构建标准化心理服务体系。
						</p>
						<div class="banner-actions">
							<a href="#contact" class="btn-primary">免费试用咨询</a>
							<a href="#function" class="btn-outline">了解核心功能</a>
						</div>
						<div class="banner-tags">
							<span class="tag-item"><i class="el-icon-success"></i>合规专业量表库</span>
							<span class="tag-item"><i class="el-icon-success"></i>数据加密存储</span>
							<span class="tag-item"><i class="el-icon-success"></i>全终端适配</span>
						</div>
					</div>
					<div class="banner-image-wrap">
						<img src="https://picsum.photos/900/560?random=10" alt="万象心理测评系统后台演示" class="banner-image">
					</div>
				</div>
			</section>

			<section class="declaration-section">
				<div class="container-custom">
					<p>
						【重要声明】本系统仅作为心理状态筛查、评估、辅助参考工具，不具备医疗诊断功能，不可替代专业医师的临床诊断。
					</p>
				</div>
			</section>

			<section id="position" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>产品核心定位</h2>
						<div class="title-line"></div>
						<p>明确服务对象与价值主张，打造心理咨询机构专属的全场景测评服务中台。</p>
					</div>
					<div class="position-grid">
						<div v-for="item in positionCards" :key="item.title" class="simple-card card-hover">
							<div class="card-icon"><i :class="item.icon"></i></div>
							<h3>{{ item.title }}</h3>
							<p>{{ item.desc }}</p>
						</div>
					</div>
				</div>
			</section>

			<section id="value" class="section-py bg-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>核心产品价值</h2>
						<div class="title-line"></div>
						<p>机构选择我们的七大核心理由，全方位赋能心理咨询机构发展。</p>
					</div>
					<div class="value-grid">
						<div v-for="item in coreValues" :key="item.title"
							:class="['value-card', item.full && 'value-card-full', 'card-hover']">
							<h3><i :class="item.icon"></i>{{ item.title }}</h3>
							<p>{{ item.desc }}</p>
						</div>
					</div>
				</div>
			</section>

			<section id="function" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>核心功能模块</h2>
						<div class="title-line"></div>
						<p>SaaS 架构，多租户与多应用设计，覆盖测评全流程核心功能。</p>
					</div>
					<div class="function-grid">
						<div class="function-column">
							<div class="panel card-hover">
								<h3>机构总管理后台（核心中台）</h3>
								<ul>
									<li v-for="item in backendFeatures" :key="item">{{ item }}</li>
								</ul>
							</div>
							<div class="panel card-hover">
								<h3>测评任务管理（全场景通用）</h3>
								<ul>
									<li v-for="item in taskFeatures" :key="item">{{ item }}</li>
								</ul>
							</div>
							<div class="panel card-hover">
								<h3>量表库体系（专业・合规・可扩展）</h3>
								<div class="scale-tags">
									<span v-for="item in scaleCategories" :key="item">{{ item }}</span>
								</div>
								<p class="small-text">支持自主上传自编量表，灵活配置题目与计分规则，满足个性化评估需求。</p>
							</div>
						</div>
						<div class="function-column">
							<img src="https://picsum.photos/900/700?random=20" alt="心理测评系统功能演示"
								class="function-image card-hover">
							<div class="panel card-hover">
								<h3>报告与数据分析 + 全终端用户端</h3>
								<div class="double-list">
									<div>
										<h4>核心报告能力</h4>
										<ul>
											<li v-for="item in reportFeatures" :key="item">{{ item }}</li>
										</ul>
									</div>
									<div>
										<h4>全终端用户端</h4>
										<ul>
											<li v-for="item in terminalFeatures" :key="item">{{ item }}</li>
										</ul>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>

			<section id="scene" class="section-py bg-soft">
				<div class="container-custom">
					<div class="section-head">
						<h2>全场景解决方案</h2>
						<div class="title-line"></div>
						<p>覆盖政企、学校、大众、社区，打造全领域心理测评服务能力。</p>
					</div>
					<div class="scene-grid">
						<div v-for="item in sceneCards" :key="item.title" class="scene-card card-hover">
							<div class="scene-icon"><i :class="item.icon"></i></div>
							<h3>{{ item.title }}</h3>
							<p>{{ item.desc }}</p>
						</div>
					</div>
				</div>
			</section>

			<section id="cooperation" class="section-py">
				<div class="container-custom">
					<div class="section-head">
						<h2>合作与服务保障</h2>
						<div class="title-line"></div>
						<p>全方位技术、服务、安全保障，多种合作模式适配不同机构需求。</p>
					</div>
					<div class="guarantee-grid">
						<div v-for="item in guarantees" :key="item.title" class="simple-card card-hover center">
							<div class="card-icon"><i :class="item.icon"></i></div>
							<h3 style="margin-top: 20px;">{{ item.title }}</h3>
							<p>{{ item.desc }}</p>
						</div>
					</div>
					<div class="cooperation-wrap">
						<h3>多元化合作模式（面向心理咨询机构）</h3>
						<div class="cooperation-grid">
							<div v-for="item in cooperationModes" :key="item.title" class="cooperation-card card-hover">
								<h4>{{ item.title }}</h4>
								<p>{{ item.desc }}</p>
							</div>
						</div>
					</div>
				</div>
			</section>
			<SiteFooter />
		</main>
	</div>
</template>

<script>
	import Head from '@/components/head/index.vue'
	import SiteFooter from '@/components/footer/index.vue'

	export default {
		name: 'SolutionManual',
		components: {
			Head,
			SiteFooter
		},
		data() {
			return {
				positionCards: [{
						title: '产品名称',
						desc: '万象心理测评 SaaS 云服务平台',
						icon: 'el-icon-price-tag'
					},
					{
						title: '核心服务对象',
						desc: '上游：心理咨询机构；下游：大众、政企、学校等。',
						icon: 'el-icon-user'
					},
					{
						title: '核心 Slogan',
						desc: '一平台·多应用·全终端·专属化',
						icon: 'el-icon-view'
					}
				],
				coreValues: [{
						title: '独立运营，品牌自主',
						desc: '自定义 LOGO、域名、数据归属，打造专属品牌，提升机构市场辨识度。',
						icon: 'el-icon-briefcase'
					},
					{
						title: '一账号多应用，场景自由拆分',
						desc: '创建多个独立应用，数据隔离，满足机构多业务线差异化运营需求。',
						icon: 'el-icon-connection'
					},
					{
						title: '全终端适配，触达无死角',
						desc: '支持 PC、H5、公众号、小程序，覆盖所有使用场景，便捷触达各类用户。',
						icon: 'el-icon-mobile-phone'
					},
					{
						title: '量表合规专业，信效度保障',
						desc: '内置标准量表，支持自定义配置，确保测评专业性、合规性与科学性。',
						icon: 'el-icon-document-checked'
					},
					{
						title: '高效自动化，降低人力成本',
						desc: '批量操作，自动生成专业测评报告，显著提升机构服务效率与产能。',
						icon: 'el-icon-rocket'
					},
					{
						title: '数据安全合规，隐私全程保护',
						desc: '加密存储，操作留痕，符合国家隐私保护法规，保障用户与机构数据安全。',
						icon: 'el-icon-lock'
					},
					{
						title: '全场景覆盖，拓展机构营收',
						desc: '从一对一专属咨询到规模化测评服务，实现多场景商业变现，提升整体商业价值。',
						icon: 'el-icon-data-line',
						full: true
					}
				],
				backendFeatures: [
					'多应用管理，业务模块化精细化运营',
					'品牌自定义配置，快速打造企业级品牌形象',
					'多级权限管理，细粒度控制数据访问权限',
					'账户与套餐管理，按需计费灵活调整'
				],
				taskFeatures: [
					'批量任务创建，配置灵活满足多样化需求',
					'Excel 导入名单，实名/匿名作答模式可选',
					'链接/二维码分发，多渠道触达用户更便捷',
					'进度实时监控，一键催答提升作答率'
				],
				scaleCategories: [
					'心理健康筛查',
					'人格与特质评估',
					'职业与招聘适配',
					'青少年/学生专用',
					'团体与社会心理',
					'自定义量表上传'
				],
				reportFeatures: [
					'个人报告自动生成，支持 PDF 导出',
					'团体统计报告，多维度对比分析',
					'学生心理档案，追踪成长曲线',
					'招聘专属报告，科学人才筛选'
				],
				terminalFeatures: [
					'PC 网页端：批量作答高效便捷',
					'H5 移动端：传播便捷触达率高',
					'公众号：绑定私域提升粘性',
					'小程序：轻量化入口留存更高'
				],
				sceneCards: [{
						title: '政企单位',
						desc: '提供心理健康普查与人才招聘测评服务，通过科学数据辅助企业人力资源管理决策，提升团队心理健康水平与人才匹配度。',
						icon: 'el-icon-office-building'
					},
					{
						title: '学校教育',
						desc: '建立学生电子化心理档案，开展常态化心理普查，全方位守护学生心理健康成长，为校园心理工作提供数据支撑与决策依据。',
						icon: 'el-icon-reading'
					},
					{
						title: '大众/用户',
						desc: '提供便捷线上自测工具，利用私域流量精准引流，实现从线上测评到线下咨询的高效转化。',
						icon: 'el-icon-user'
					},
					{
						title: '社区/医疗',
						desc: '提供快速心理初筛与专业随访评估工具，优化公共心理健康服务资源配置，提升基层心理服务效率。',
						icon: 'el-icon-first-aid-kit'
					}
				],
				guarantees: [{
						title: '技术特性',
						desc: 'SaaS 公有云部署，开箱即用，高并发支撑，7x24 小时稳定运行，支持私有化部署定制。',
						icon: 'el-icon-setting'
					},
					{
						title: '专业服务',
						desc: '提供从开通配置、操作培训到日常技术支持、定制化开发的全流程专业服务。',
						icon: 'el-icon-service'
					},
					{
						title: '安全承诺',
						desc: '数据所有权 100% 归属机构，严格遵守国家隐私保护法规，加密存储、操作留痕。',
						icon: 'el-icon-lock'
					}
				],
				cooperationModes: [{
						title: 'SaaS 按年授权',
						desc: '适合长期稳定使用的机构，享受无限制系统功能与持续更新服务，性价比更高。'
					},
					{
						title: '按测评人次计费',
						desc: '适合轻量使用或阶段性项目，灵活投入，按实际产生的测评量结算，成本可控。'
					},
					{
						title: '专属品牌版',
						desc: '支持独立域名、专属界面及个性化功能开发，打造机构独家系统。'
					},
					{
						title: '渠道合作',
						desc: '支持多级分销和子账号代理模式，携手合作伙伴共同拓展市场，实现互利共赢。'
					}
				],
				contactPersons: [{
						name: '张先生',
						phone: '13161072501'
					},
					{
						name: '许女士',
						phone: '15031192537'
					},
					{
						name: '安先生',
						phone: '18932907651'
					}
				],
				consultationForm: {
					name: '',
					phone: '',
					org: '',
					demand: '',
					desc: ''
				}
			}
		},
		mounted() {
			this.scrollToHashTarget()
		},
		watch: {
			'$route.hash'() {
				this.scrollToHashTarget()
			}
		},
		methods: {
			scrollToHashTarget() {
				if (!this.$route.hash) {
					return
				}
				this.$nextTick(() => {
					const target = document.querySelector(this.$route.hash)
					if (target) {
						target.scrollIntoView({
							behavior: 'smooth',
							block: 'start'
						})
					}
				})
			},
			handleConsultSubmit() {
				window.alert('咨询信息提交成功！我们将尽快与您联系。')
				this.consultationForm = {
					name: '',
					phone: '',
					org: '',
					demand: '',
					desc: ''
				}
			}
		}
	}
</script>

<style scoped>
	.solution-manual-page {
		background: #fff;
		color: #1f2937;
	}

	.manual-main {
		padding-top: 64px;
	}

	.section-py {
		padding: 68px 0;
	}

	.bg-soft {
		background: #f8fafc;
	}

	.container-custom {
		max-width: 1240px;
		margin: 0 auto;
		padding: 0 20px;
	}

	.section-head {
		max-width: 760px;
		margin: 0 auto 40px;
		text-align: center;
	}

	.section-head h2 {
		margin: 0;
		font-size: clamp(30px, 4vw, 44px);
		line-height: 1.3;
		color: #212529;
	}

	.section-head p {
		margin: 0;
		font-size: 17px;
		line-height: 1.75;
		color: #5f6f82;
	}

	.title-line {
		width: 82px;
		height: 4px;
		margin: 18px auto;
		background: linear-gradient(90deg, #366b9e, #8fb4d9);
		border-radius: 999px;
	}

	.card-hover {
		transition: all 0.25s ease;
	}

	.card-hover:hover {
		transform: translateY(-4px);
		box-shadow: 0 16px 30px rgba(54, 107, 158, 0.12);
	}

	.banner-section {
		background: linear-gradient(145deg, #f8f9fa 0%, #edf5ff 100%);
	}

	.banner-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 32px;
		align-items: center;
	}

	.banner-title {
		margin: 0 0 18px;
		font-size: clamp(34px, 5vw, 60px);
		line-height: 1.2;
		font-weight: 700;
		color: #212529;
	}

	.banner-desc {
		margin: 0;
		font-size: 19px;
		line-height: 1.75;
		color: #495057;
		max-width: 660px;
	}

	.banner-actions {
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		margin: 24px 0 18px;
	}

	.btn-primary,
	.btn-outline {
		display: inline-flex;
		align-items: center;
		justify-content: center;
		padding: 12px 26px;
		border-radius: 10px;
		font-size: 15px;
		line-height: 1;
		font-weight: 600;
		text-decoration: none;
		cursor: pointer;
	}

	.btn-primary {
		border: 1px solid #366b9e;
		background: #366b9e;
		color: #fff;
	}

	.btn-primary:hover {
		background: #2c5b89;
	}

	.btn-outline {
		border: 1px solid #366b9e;
		color: #366b9e;
		background: transparent;
	}

	.btn-outline:hover {
		background: rgba(54, 107, 158, 0.08);
	}

	.btn-primary.full {
		width: 100%;
	}

	.banner-tags {
		display: flex;
		flex-wrap: wrap;
		gap: 14px;
	}

	.tag-item {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		font-size: 14px;
		color: #4b5563;
	}

	.tag-item i {
		color: #366b9e;
	}

	.banner-image-wrap {
		background: #fff;
		padding: 10px;
		border-radius: 18px;
		box-shadow: 0 10px 26px rgba(15, 23, 42, 0.08);
	}

	.banner-image {
		display: block;
		width: 100%;
		height: auto;
		border-radius: 14px;
	}

	.declaration-section {
		padding: 14px 0;
		background: rgba(54, 107, 158, 0.1);
	}

	.declaration-section p {
		margin: 0;
		text-align: center;
		font-size: 14px;
		color: #45556a;
	}

	.position-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 16px;
	}

	.simple-card,
	.value-card,
	.panel,
	.scene-card,
	.cooperation-card,
	.contact-form {
		border: 1px solid #e6edf6;
		border-radius: 14px;
		background: #fff;
	}

	.simple-card {
		padding: 26px 22px;
	}

	.simple-card.center {
		text-align: center;
	}

	.card-icon {
		width: 56px;
		height: 56px;
		margin-bottom: 14px;
		border-radius: 50%;
		background: rgba(54, 107, 158, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
		margin: 0 auto;
	}

	.card-icon i {
		font-size: 28px;
		color: #366b9e;
	}

	.simple-card h3,
	.scene-card h3 {
		margin: 0 0 10px;
		font-size: 24px;
		color: #212529;
	}

	.simple-card p,
	.scene-card p {
		margin: 0;
		font-size: 15px;
		line-height: 1.75;
		color: #5f6f82;
	}

	.value-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 16px;
	}

	.value-card {
		padding: 22px 18px;
	}

	.value-card h3 {
		margin: 0 0 10px;
		font-size: 21px;
		display: flex;
		align-items: center;
		gap: 8px;
		color: #212529;
	}

	.value-card h3 i {
		color: #366b9e;
		font-size: 22px;
	}

	.value-card p {
		margin: 0;
		font-size: 15px;
		line-height: 1.7;
		color: #5f6f82;
	}

	.value-card-full {
		grid-column: span 3;
		background: #eef5fc;
		border-color: #d8e8f7;
	}

	.function-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 18px;
	}

	.function-column {
		display: flex;
		flex-direction: column;
		gap: 18px;
	}

	.panel {
		padding: 20px 18px;
	}

	.panel h3 {
		margin: 0 0 12px;
		font-size: 24px;
		color: #366b9e;
	}

	.panel ul {
		margin: 0;
		padding: 0;
		list-style: none;
	}

	.panel li {
		position: relative;
		padding-left: 20px;
		margin-bottom: 10px;
		font-size: 15px;
		line-height: 1.7;
		color: #4b5563;
	}

	.panel li::before {
		content: '';
		position: absolute;
		left: 0;
		top: 9px;
		width: 8px;
		height: 8px;
		border-radius: 50%;
		background: #366b9e;
	}

	.scale-tags {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 8px;
		margin-bottom: 10px;
	}

	.scale-tags span {
		padding: 8px 10px;
		border: 1px solid #dbe7f4;
		border-radius: 8px;
		background: #f8fbff;
		font-size: 14px;
		color: #4b5563;
	}

	.small-text {
		margin: 0;
		font-size: 14px;
		line-height: 1.7;
		color: #5f6f82;
	}

	.function-image {
		display: block;
		width: 100%;
		height: auto;
		border-radius: 14px;
		box-shadow: 0 10px 24px rgba(17, 24, 39, 0.12);
	}

	.double-list {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 14px;
	}

	.double-list h4 {
		margin: 0 0 8px;
		font-size: 18px;
		color: #2c5b89;
	}

	.scene-grid {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 16px;
	}

	.scene-card {
		padding: 24px 18px;
		text-align: center;
	}

	.scene-icon {
		width: 60px;
		height: 60px;
		margin: 0 auto 14px;
		border-radius: 50%;
		background: rgba(54, 107, 158, 0.1);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.scene-icon i {
		font-size: 28px;
		color: #366b9e;
	}

	.guarantee-grid {
		display: grid;
		grid-template-columns: repeat(3, minmax(0, 1fr));
		gap: 16px;
	}

	.cooperation-wrap {
		margin-top: 22px;
		padding: 24px 20px;
		border: 1px solid #e6edf6;
		border-radius: 16px;
		background: #f8fafc;
	}

	.cooperation-wrap h3 {
		margin: 0 0 16px;
		text-align: center;
		font-size: 24px;
		color: #366b9e;
	}

	.cooperation-grid {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 14px;
	}

	.cooperation-card {
		padding: 20px 16px;
		text-align: center;
	}

	.cooperation-card h4 {
		margin: 0 0 8px;
		font-size: 18px;
		color: #212529;
	}

	.cooperation-card p {
		margin: 0;
		font-size: 14px;
		line-height: 1.7;
		color: #5f6f82;
	}

	.contact-section {
		background: rgba(54, 107, 158, 0.06);
	}

	.contact-grid {
		display: grid;
		grid-template-columns: 2fr 1fr;
		gap: 18px;
	}

	.contact-form {
		padding: 24px;
	}

	.form-grid {
		display: grid;
		grid-template-columns: repeat(2, minmax(0, 1fr));
		gap: 14px;
	}

	.form-item {
		margin-bottom: 14px;
	}

	.form-item label {
		display: block;
		margin-bottom: 6px;
		font-size: 14px;
		color: #374151;
	}

	.form-item input,
	.form-item select,
	.form-item textarea {
		width: 100%;
		padding: 10px 12px;
		font-size: 14px;
		color: #1f2937;
		border: 1px solid #d4dde8;
		border-radius: 8px;
		outline: none;
		box-sizing: border-box;
	}

	.form-item input:focus,
	.form-item select:focus,
	.form-item textarea:focus {
		border-color: #8fb4d9;
		box-shadow: 0 0 0 3px rgba(143, 180, 217, 0.2);
	}

	.contact-aside {
		padding: 26px 22px;
		border-radius: 14px;
		background: #366b9e;
		color: #fff;
	}

	.contact-aside h3 {
		margin: 0 0 18px;
		font-size: 28px;
	}

	.contact-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
	}

	.contact-item {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.contact-icon {
		width: 42px;
		height: 42px;
		border-radius: 999px;
		background: rgba(255, 255, 255, 0.2);
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.contact-icon i {
		font-size: 20px;
	}

	.contact-name {
		margin: 0 0 2px;
		font-size: 13px;
		opacity: 0.85;
	}

	.contact-phone {
		margin: 0;
		font-size: 18px;
		font-weight: 600;
	}

	.company-info {
		margin-top: 20px;
		padding-top: 14px;
		border-top: 1px solid rgba(255, 255, 255, 0.25);
	}

	.company-info p {
		margin: 0 0 4px;
		font-size: 13px;
		opacity: 0.85;
	}

	.company-info h4 {
		margin: 0;
		font-size: 18px;
	}

	@media (max-width: 1200px) {
		.scene-grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.cooperation-grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
	}

	@media (max-width: 992px) {
		.manual-main {
			padding-top: 56px;
		}

		.section-py {
			padding: 48px 0;
		}

		.banner-grid,
		.function-grid,
		.contact-grid {
			grid-template-columns: 1fr;
		}

		.position-grid,
		.value-grid,
		.guarantee-grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.value-card-full {
			grid-column: span 2;
		}
	}

	@media (max-width: 768px) {
		.container-custom {
			padding: 0 14px;
		}

		.section-py {
			padding: 34px 0;
		}

		.banner-title {
			font-size: 32px;
		}

		.banner-desc {
			font-size: 15px;
		}

		.position-grid,
		.value-grid,
		.double-list,
		.scene-grid,
		.guarantee-grid,
		.cooperation-grid,
		.form-grid,
		.scale-tags {
			grid-template-columns: 1fr;
		}

		.value-card-full {
			grid-column: auto;
		}

		.simple-card h3,
		.scene-card h3,
		.panel h3,
		.cooperation-wrap h3 {
			font-size: 20px;
		}

		.contact-aside h3 {
			font-size: 22px;
		}
	}
</style>